import Validator from './Validator'

class ESvalidator extends Validator {
  strategy() {
    return this.res
  }
}

export default ESvalidator
